module.exports = __webpack_public_path__ + "images/emoji/satisfied.b6104822e96c457e0eee.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/satisfied.png
// module id = GJZd
// module chunks = 14